import axios from 'axios'
const base_URL = `${process.env.REACT_APP_BASE_URL}/api/patients`
export const getPatients = () => axios.get(base_URL)
export const getPatientById = (id) => axios.get(base_URL+ '/' + id)